var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "header" } },
    [
      _c(
        "Row",
        [
          _c(
            "Col",
            { attrs: { xs: 0, sm: 0, md: 14, lg: 14, xl: 14 } },
            [
              _c("div", { staticClass: "logo-info" }, [
                _c("p", { staticClass: "name" }, [_vm._v("孤独症测评系统")]),
              ]),
              _c("IBreadcrumb"),
            ],
            1
          ),
          _c(
            "Col",
            { attrs: { xs: 4, sm: 2, md: 0, lg: 0, xl: 0 } },
            [
              _c(
                "Poptip",
                {
                  staticClass: "navigation",
                  attrs: { placement: "right-start" },
                  model: {
                    value: _vm.visible,
                    callback: function ($$v) {
                      _vm.visible = $$v
                    },
                    expression: "visible",
                  },
                },
                [
                  _c("Icon", {
                    staticClass: "nav-icon",
                    attrs: { type: "md-menu", size: "32" },
                  }),
                  _c("ISidebar", {
                    ref: "navigation",
                    attrs: { slot: "content" },
                    on: { "on-click": _vm.handleClose },
                    slot: "content",
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Col",
            {
              staticStyle: { display: "flex", "justify-content": "flex-end" },
              attrs: { xs: 20, sm: 22, md: 10, lg: 10, xl: 10 },
            },
            [
              _c(
                "span",
                { staticClass: "areaBanner", on: { click: _vm.showEditArea } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.userType >= 6 &&
                        (!_vm.institutions || _vm.institutions.length <= 1)
                        ? ""
                        : "切换机构"
                    )
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "login-info" },
                [
                  _c(
                    "Dropdown",
                    {
                      attrs: { placement: "bottom-end", trigger: "click" },
                      on: { "on-click": _vm.handleDropdown },
                    },
                    [
                      _c(
                        "strong",
                        { staticClass: "user" },
                        [
                          _c("Avatar", {
                            staticStyle: { "background-color": "#1890ff" },
                            attrs: { icon: "md-person", size: "small" },
                          }),
                          _vm._v("您好, " + _vm._s(_vm.userName)),
                        ],
                        1
                      ),
                      _c(
                        "DropdownMenu",
                        {
                          staticClass: "list",
                          attrs: { slot: "list" },
                          slot: "list",
                        },
                        _vm._l(_vm.dropdown, function (item) {
                          return _c(
                            "DropdownItem",
                            { key: item.name, attrs: { name: item.name } },
                            [
                              _c("Icon", {
                                staticStyle: { "margin-top": "-2px" },
                                attrs: { type: item.icon, size: "16" },
                              }),
                              _vm._v(
                                " " + _vm._s(item.label) + "\n            "
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("EditPassword", { ref: "editPassword" }),
      _c("EditArea", { ref: "EditArea" }),
      _c("PersonalMsg", { ref: "personalMsg" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }